import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon, TrophyIcon } from 'lucide-react';
import { tomoIncludes, tomos } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
const values = ['560+ páginas de material', '6 Tomos completos', 'Iniciación → Competitivo', 'Los 5 aparatos cubiertos', 'Clases listas para usar', 'Adaptado para Argentina'];
export function ProductOverview() {
  const [open, setOpen] = useState(0);
  return <section className="mx-auto max-w-5xl px-4 py-12 md:py-16" data-id="element-276" data-mp="1tnf7sg37ex64">
      <Eyebrow data-id="element-277" data-mp="1omhsqcdhqj8u">
        <span className="inline-flex items-center gap-2" data-id="element-278" data-mp="1oo2djaa06nti">
          <TrophyIcon aria-hidden="true" className="h-4 w-4" data-id="element-279" data-mp="1jny8cgejpfil" /> Gimnasia Rítmica PRO — Mega Bundle
          Completo
        </span>
      </Eyebrow>
      <SectionTitle data-id="element-280" data-mp="3ixmu1a13ujl0">
        6 Tomos + 6 Bonos. <span className="text-gold" data-id="element-281" data-mp="3e0o0otp9mgnv">Todo resuelto.</span>
      </SectionTitle>
      <p className="mt-4 text-center font-medium text-zinc-300" data-id="element-282" data-mp="10drlcvyeyrv3">
        De la primera clase de iniciación al año competitivo planificado. Listo para aplicar hoy.
      </p>

      <ul className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-3" data-id="element-283" data-mp="15ai1fja7xngi">
        {values.map(value => <li key={value} className="flex items-center gap-3 rounded-xl border border-line bg-surface p-4" data-id="element-284" data-mp="qheqhur4u7yr">
            <span aria-hidden="true" className="rounded-lg bg-gold/15 p-2" data-id="element-285" data-mp="1j3pttd64imz9">
              <CheckIcon className="h-4 w-4 text-gold" data-id="element-286" data-mp="1o2szmztxgx8a" />
            </span>
            <span className="text-sm font-bold leading-tight text-white" data-id="element-287" data-mp="1o55h7bvrx5kt">{value}</span>
          </li>)}
      </ul>

      <div className="mt-16" data-id="element-288" data-mp="1eczo1ytsci41">
        <h3 className="mx-auto max-w-3xl text-center text-2xl font-black leading-tight text-white md:text-4xl" data-id="element-289" data-mp="1ec7rakogcec6">
          6 tomos para <span className="text-gold" data-id="element-290" data-mp="221ivyd8xasvl">dar cualquier clase con confianza.</span>
        </h3>
        <p className="mt-3 text-center text-sm font-medium text-zinc-400" data-id="element-291" data-mp="26v4znfx3zmf9">
          Tocá un tomo para ver el contenido
        </p>
        <div className="mt-8 space-y-3" data-id="element-292" data-mp="2gn6ghzj1fzez">
          {tomos.map((tomo, index) => {
          const isOpen = open === index;
          return <div key={tomo.name} className={`overflow-hidden rounded-2xl border bg-surface transition-colors duration-150 ease-smooth ${isOpen ? 'border-gold' : 'border-line'}`} data-id="element-293" data-mp="27nt7f7yttcus" data-mpi={index}>
                <button type="button" className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-7 md:py-5" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? -1 : index)} data-id="element-294" data-mp="1t083xcy1hbmc">
                  <span className="flex items-center gap-3" data-id="element-295" data-mp="1f0729v9ya05t">
                    <span aria-hidden="true" className="text-2xl" data-id="element-296" data-mp="1eznmol7rvnuy">
                      {tomo.icon}
                    </span>
                    <span data-id="element-297" data-mp="1a3gesmvtg2ad">
                      <b className="block text-white" data-id="element-298" data-mp="3loz246u53a39">
                        Tomo {index + 1} — {tomo.name}
                      </b>
                      <small className="font-bold text-gold" data-id="element-299" data-mp="3qlz5ub3io0r7">{tomo.period}</small>
                    </span>
                  </span>
                  <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-180' : ''}`} data-id="element-300" data-mp="3vksmudi0i9w4" />
                </button>
                <AnimatePresence initial={false} data-id="element-301" data-mp="37uoha0l9k02h">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-302" data-mp="3bwji73za8bfq">
                      <ul className="space-y-2 border-t border-line px-5 py-4 text-sm font-medium text-zinc-300 md:px-7" data-id="element-303" data-mp="2o6p5qnivkow0">
                        {tomo.content.map(line => <li key={line} className="flex gap-2" data-id="element-304" data-mp="2076qlpv20god">
                            <span aria-hidden="true" className="text-gold" data-id="element-305" data-mp="2eui3pw6vw8ql">
                              →
                            </span>
                            {line}
                          </li>)}
                      </ul>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10 rounded-3xl border border-gold/25 bg-surface p-6 md:p-8" data-id="element-306" data-mp="2xs2puvi9kt7i">
          <h4 className="text-center text-lg font-black uppercase tracking-wide text-gold md:text-xl" data-id="element-307" data-mp="2strg0kryyipa">
            Cada tomo incluye
          </h4>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-308" data-mp="13h75yx1mprpf">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-zinc-200" data-id="element-309" data-mp="yiclzrrxdx3q">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-310" data-mp="3f2gelpkcyerx" />
                {item}
              </li>)}
          </ul>
          <div className="mt-8 text-center" data-id="element-311" data-mp="30d0ombsnidda">
            <Button href="#pricing" className="w-full text-sm md:w-auto md:text-base" data-id="element-312" data-mp="35cdc8yrcjogx">
              Sí, quiero los 6 tomos completos →
            </Button>
          </div>
        </div>
      </div>
    </section>;
}